import { MakeApiCall } from "../../../../apis";

export async function fetchChatUsers({ page = 1, perPage = 20, q = "" } = {}, token) {
  const params = new URLSearchParams({
    page: String(page),
    per_page: String(perPage),
  });
  if (q) params.set("q", q);
  const url = `admin/ai-chat/users?${params.toString()}`;
  const res = await MakeApiCall(url, "get", null, true, {}, token);
  if (!res?.status) throw new Error(res?.message || "Failed to load users");
  return {
    items: res?.data?.items || [],
    pagination: res?.data?.pagination || { total: 0, page: 1, per_page: perPage, pages: 1 },
  };
}

export async function fetchUserSessions(userId, { page = 1, perPage = 20 } = {}, token) {
  const params = new URLSearchParams({
    page: String(page),
    per_page: String(perPage),
  });
  const url = `admin/ai-chat/users/${userId}/sessions?${params.toString()}`;
  const res = await MakeApiCall(url, "get", null, true, {}, token);
  if (!res?.status) throw new Error(res?.message || "Failed to load sessions");
  return {
    items: res?.data?.items || [],
    pagination: res?.data?.pagination || { total: 0, page: 1, per_page: perPage, pages: 1 },
  };
}

export async function fetchSessionTranscript(userId, sessionId, token) {
  const url = `admin/ai-chat/users/${userId}/sessions/${sessionId}`;
  const res = await MakeApiCall(url, "get", null, true, {}, token);
  if (!res?.status) throw new Error(res?.message || "Failed to load transcript");
  return res?.data || null;
}
